import { useFrame, useThree } from '@react-three/fiber';
import { OrthographicCamera, Vector3 } from 'three';
import { useGameStore } from '../../simulation/store';

const targetVector = new Vector3();
const desiredPosition = new Vector3();
const lookTarget = new Vector3();

export function CameraRig() {
  const { camera } = useThree();
  const cameraState = useGameStore((state) => state.camera);
  const walk = useGameStore((state) => state.walk);

  useFrame(() => {
    const orthoCamera = camera as OrthographicCamera;

    if (walk.active) {
      const eyeHeight = 1.3;
      desiredPosition.set(walk.position.x, eyeHeight, walk.position.z);
      lookTarget.set(
        walk.position.x + Math.sin(walk.heading) * 4,
        eyeHeight - 0.08,
        walk.position.z + Math.cos(walk.heading) * 4
      );
      camera.position.lerp(desiredPosition, 0.2);
      camera.lookAt(lookTarget);
      orthoCamera.zoom += (72 - orthoCamera.zoom) * 0.08;
      orthoCamera.updateProjectionMatrix();
      return;
    }

    targetVector.set(cameraState.target.x, cameraState.target.y, cameraState.target.z);
    desiredPosition.set(
      targetVector.x + Math.sin(cameraState.rotation) * 14,
      Math.max(12, cameraState.zoom * 0.78),
      targetVector.z + Math.cos(cameraState.rotation) * 14
    );
    camera.position.lerp(desiredPosition, 0.11);
    camera.lookAt(targetVector);
    orthoCamera.zoom += (cameraState.zoom - orthoCamera.zoom) * 0.08;
    orthoCamera.updateProjectionMatrix();
  });

  return null;
}
